// extracted by mini-css-extract-plugin
module.exports = {"downloadBtnWrapper":"styles_downloadBtnWrapper__UtTSk","download":"styles_download__1PBxf"};